let current = '';

export function setCallTabId(id) {
  current = id ? String(id) : '';
}

export function getCallTabId() {
  return current;
}
